<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ $t('report.modify_project') }}</div>
    <div slot="body">
      <dialog-selected-tips :count="params.data.length" :action="$t('report.modify_project')" :name="$t('dictionary.extdb')" />
      <dialog-table v-if="params.columns && params.columns.length" :data="params.data" :columns="params.columns.slice(0, 3)" />
      <a-form-model
        ref="form"
        :model="form"
        :rules="rules"
        v-bind="formItemLayout">
        <a-form-model-item :label="$t('dictionary.project')">
          <a-row :gutter="8">
            <a-col :span="12">
              <base-select
                v-model="form.domain_id"
                resource="domains"
                :params="domainParams"
                remote>
                <template #optionTemplate="{ options }">
                  <a-select-option v-for="item of options" :key="item.id" :value="item.id" :label="item.name">
                    <span class="text-color-secondary option-prefix mr-2">{{$t('dictionary.domain')}}:</span>{{item.name}}
                  </a-select-option>
                </template>
              </base-select>
            </a-col>
            <a-col :span="12">
              <base-select
                v-model="form.tenant_id"
                resource="projects"
                :params="projectParams"
                remote>
                <template #optionTemplate="{ options }">
                  <a-select-option v-for="item of options" :key="item.id" :value="item.id" :label="item.name">
                    <span class="text-color-secondary option-prefix mr-2">{{$t('dictionary.project')}}:</span>{{item.name}}
                  </a-select-option>
                </template>
              </base-select>
            </a-col>
          </a-row>
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t("dialog.ok") }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'

export default {
  name: 'ExtResourceChangeProjectDialog',
  components: {
  },
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      form: {
        domain_id: this.params.data[0].domain_id,
        tenant_id: this.params.data[0].tenant_id,
      },
      selectFormatter: null,
      formItemLayout: {
        wrapperCol: {
          span: 20,
        },
        labelCol: {
          span: 4,
        },
      },
    }
  },
  computed: {
    domainParams () {
      return {
        scope: this.$store.getters.scope,
        limit: 20,
      }
    },
    projectParams () {
      return {
        scope: this.$store.getters.scope,
        limit: 20,
        domain_id: this.form.domain_id,
      }
    },
  },
  created () {
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        await this.params.onManager('batchUpdate', {
          id: this.params.data.map(item => item.id),
          managerArgs: {
            data: { tenant_id: this.form.tenant_id || '' },
          },
        })
        this.cancelDialog()
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
